var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", sm: "6" } },
        [
          _c("w-input-number", {
            attrs: { label: "mod id", fancy: "", decimals: 0 },
            model: {
              value: _vm.mod.id,
              callback: function ($$v) {
                _vm.$set(_vm.mod, "id", $$v)
              },
              expression: "mod.id",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", sm: "6" } },
        [
          _c("w-input", {
            attrs: { label: "module name", fancy: "" },
            model: {
              value: _vm.mod.name,
              callback: function ($$v) {
                _vm.$set(_vm.mod, "name", $$v)
              },
              expression: "mod.name",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", sm: "6", md: "4", lg: "3" } },
        [
          _c("w-input-number", {
            attrs: { label: "Price", fancy: "" },
            model: {
              value: _vm.mod.price,
              callback: function ($$v) {
                _vm.$set(_vm.mod, "price", $$v)
              },
              expression: "mod.price",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", sm: "6", md: "4", lg: "3" } },
        [
          _c("w-input-number", {
            attrs: { label: "Permanent Price", fancy: "" },
            model: {
              value: _vm.mod.permanentPrice,
              callback: function ($$v) {
                _vm.$set(_vm.mod, "permanentPrice", $$v)
              },
              expression: "mod.permanentPrice",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }